import React from "react"
import { StaticQuery, graphql } from "gatsby"

import FeatureHero from "../featureHero"
import Img from "./image"
import { H2 } from "../typography"
// import illustraion from "../../images/service-illustration.svg"

const columns = [
  {
    span: 6,
    type: "image",
  },
  {
    span: 6,
    type: "text",
  },
]

// const Img = () => <img src={illustraion} />

const RenderComponent = data => {
  const { title, description } = data.yaml.content.service

  return (
    <FeatureHero
      margin={{ tablet: "300px auto 100px" }}
      image={Img}
      title={title}
      description={description}
      columns={columns}
      titleType={H2}
    />
  )
}

const HomeService = () => {
  return (
    <StaticQuery
      query={graphql`
        {
          yaml: contentYaml(header: { slug: { eq: "/index" } }) {
            content {
              service {
                description
                title
              }
            }
          }
        }
      `}
      render={RenderComponent}
    />
  )
}

export default HomeService
